// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2b0627e5","885":"13493404"}[chunkId] + ".chunk.js";
};